module.exports = __webpack_public_path__ + "static/media/backsplashPlain.50a10385.png";